<template>
  <v-container 
    :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-0': $vuetify.breakpoint.mdAndUp,
    }"
  >
    <v-layout justify-center
      ><!--este manda que no se me olvide-->
      <v-flex md8>
        <v-form ref="form">
          <!--STEPPER-->
          <v-stepper v-model="a1">
            <v-stepper-header style="display: none">
              <v-stepper-step
                :complete="a1 > 1"
                step="1"
                complete-icon="fas fa-check subheading"
                edit-icon="fas fa-check subheading"
                error-icon="fas fa-exclamation-triangle subheading"
                color="#1f97b9"
                editable
              >
              </v-stepper-step>
              <v-stepper-step
                :complete="a1 > 2"
                step="2"
                complete-icon="fas fa-check subheading"
                edit-icon="fas fa-check subheading"
                error-icon="fas fa-exclamation-triangle subheading"
                color="#1f97b9"
                editable
              ></v-stepper-step>
            </v-stepper-header>

            <!--INICIO CONTENIDO DE LOS STEPS-->
            <v-stepper-content step="1">
              <!--ORIGEN-->

              <v-flex 
                :class="{
                  'px-0': $vuetify.breakpoint.smAndDown,
                  'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-toolbar color="#1f97b9" dark>
                  <img
                    :src="
                      require('../../../assets/static/img/direccion-o-d.png')"
                      alt="icono de direcciones"
                    style="width: 30px; margin-right: 16px"
                  />
                  <v-toolbar-title>Dirección de Origen</v-toolbar-title>
                </v-toolbar>
                <v-flex
                  :class="{
                    'px-0': $vuetify.breakpoint.smAndDown,
                    'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                <!--direccionorigen-->
                  <v-layout sm10>
                    <v-flex class="d-flex">
                      <v-text-field
                        label="Ingresa calle, número y luego selecciona la sugerencia"
                        v-model="datos.direccion_origen.direccion"
                        id="starting_address"
                        :rules="rules.direccionOrigen"
                        placeholder="Sólo Calle y Número"
                        v-on:change="datos.direccion_origen.marker = {}"
                        required
                        :disabled="campoDeshabilitado" 
                        
                      >
                      </v-text-field>

                      <v-btn
                        class="btn-editar"
                        icon
                        dark
                        :disabled="campoDeshabilitado == false" 
                        @click="campoDeshabilitado ? campoDeshabilitado = false : campoDeshabilitado = true"
                        >
                        <v-img
                          style="max-heigth: 75px; max-width: 75px"
                          :src="require('../../../assets/static/img/LapizInvertido.png')"
                           alt="imagen lapiz invertido">
                        </v-img>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <!--esconder esto-->
                  <v-flex v-show="Origen2" sm10>
                    <v-layout justify-center>
                      <v-flex
                        sm10
                        sm12
                        :class="{
                          'px-0': $vuetify.breakpoint.smAndDown,
                          'px-2 py-3': $vuetify.breakpoint.mdAndUp,
                        }"
                      >
                        <h3 id="texto-orige-detino">
                          ¿Qué tipo de inmueble es?
                        </h3>
                        <!--HERE-->
                        <v-select
                          :items="items"
                          append-icon="fas fa-caret-down"
                          label="tipo de propiedad"
                          :rules="rules.required"
                          v-model="datos.origen.tipo"
                          @change="cambio()"
                        ></v-select>
                        <v-text-field
                          :label="tipoPropiedad"
                          color="#1f97b9"
                          v-model="datos.origen.numero"
                          
                        ></v-text-field>
                        <v-text-field
                          v-model="datos.origen.piso"
                          type="number"
                          label="Piso"
                          color="#1f97b9"
                          required
                          :min="1"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>            
                  </v-flex>
                  
                    <v-layout v-show="Origen2" justify-end>
                        <v-btn
                          color="#1f97b9"
                          @click="a1 = 2"
                          dark
                          :disabled="datos.direccion_origen.direccion === ''"
                          ><!--@click="validate(true, 'Mudanza_Paso_1',)" click original-->
                          Siguiente
                        </v-btn>  
                    </v-layout> 
                  <!--<GmapMap
														:center="Object.keys(this.datos.direccion_origen.marker).length > 0 ? this.datos.direccion_origen.marker : {lat: -33.437637, lng: -70.650471}"
														:zoom="15"
														style="width: 100%; height: 200px"
													>
														<GmapMarker
															v-if="Object.keys(this.datos.direccion_origen.marker).length > 0"
															:position="datos.direccion_origen.marker" />
														/>
													</GmapMap>-->

                  <!--Aqui termina el menu del step 2-->

                  <!--FIN ORIGEN-->
                  <!-- inicio del boton para volver al anterior-->
                  <v-flex text-xs-center >
                    <v-btn
                      color="grey"
                      dark
                      @click="retroceder()"
                      style="margin-top: 10px;"
                    >
                      Ir a Elementos
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-stepper-content>

            <v-stepper-content step="2">
              <!--Destino-->
                <v-flex
                  :class="{
                    'pa-0': $vuetify.breakpoint.smAndDown,
                    'pr-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                  <v-toolbar color="#1f97b9" dark>
                    <img
                      :src="
                        require('../../../assets/static/img/direccion-o-d.png')"
                        alt="icono de las direcciones"
                      style="width: 30px; margin-right: 16px"
                    />
                    <v-toolbar-title>Dirección Destino</v-toolbar-title>
                  </v-toolbar>
                  
                  <!--direccion destino-->
                  <v-flex
                  :class="{
                    'px-0': $vuetify.breakpoint.smAndDown,
                    'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                  <v-layout sm10>
                    <v-flex class="d-flex">
                      <v-text-field
                        label="Ingresa calle, número y luego selecciona la sugerencia"
                        v-model="datos.direccion_destino.direccion"
                        id="destination_address"
                        :rules="rules.direccionDestino"
                        placeholder="Sólo Calle y Número"
                        v-on:change="datos.direccion_destino.marker = {}"
                        required
                        :disabled="campoDeshabilitadoD" 
                      ></v-text-field>
                      <v-btn
                        class="btn-editar-destino"
                        icon
                        dark
                        :disabled="campoDeshabilitadoD == false" 
                        @click="campoDeshabilitadoD ? campoDeshabilitadoD = false : campoDeshabilitadoD = true">
                        <v-img
                          style="max-heigth: 75px; max-width: 75px;"
                          :src="require('../../../assets/static/img/LapizInvertido.png')"
                           alt="imagen del lapiz invertido">
                        </v-img>
                      </v-btn>
                    </v-flex>
                  </v-layout> 
                   
                      <!--TODO-->

                      <!--<GmapMap
												:center="Object.keys(this.datos.direccion_destino.marker).length > 0 ? this.datos.direccion_destino.marker : {lat: -33.437637, lng: -70.650471}"
												:zoom="15"
												style="width: 100%; height: 200px"
											>
												<GmapMarker
													v-if="Object.keys(this.datos.direccion_destino.marker).length > 0"
													:position="datos.direccion_destino.marker" />
												/>
											</GmapMap>-->
              <!--TODO-->
              
                <v-flex v-show="Destino2" sm10>
                    <v-layout justify-center>
                      <v-flex
                        sm10
                        sm12
                        :class="{
                          'px-0': $vuetify.breakpoint.smAndDown,
                          'px-2 py-3': $vuetify.breakpoint.mdAndUp,
                        }"
                      >
                        <h3 id="texto-orige-detino">
                          ¿Qué tipo de inmueble?
                        </h3>

                        <v-select
                          :items="items"
                          append-icon="fas fa-caret-down"
                          label="tipo de propiedad"
                          :rules="rules.required"
                          v-model="datos.destino.tipo"
                          @change="cambioD()"
                        ></v-select>
                        <v-text-field
                          :label="tipoPropiedad2"
                          color="#1f97b9"
                          v-model="datos.destino.numero"
                        ></v-text-field>
                        <v-text-field
                          v-model="datos.destino.piso"
                          type="number"
                          label="Piso"
                          color="#1f97b9"
                          required
                          :min="1"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-layout v-show="Destino2" align-center justify-space-between>
                          <v-btn color="#1f97b9" @click="a1 = 1" dark>
                          Anterior
                        </v-btn>
                        <v-btn
                          color="#1f97b9"
                          dark
                          :disabled="datos.direccion_origen.direccion === ''"
                          @click="validate(true)"
                        >
                          Siguiente
                        </v-btn>
                      </v-layout>
                  <v-flex text-xs-center >
                    <v-btn
                      color="grey"
                      dark
                      @click="retroceder()"
                      style="margin-top: 10px;"
                    >
                      Ir a Elementos
                    </v-btn>
                  </v-flex>
                  </v-flex>
                </v-flex>
            </v-stepper-content>
            <!--FIN CONTENIDO DE LOS STEPS-->
          </v-stepper>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from "../../../events.js";
export default {
  name: "nombre",

  data() {
    return {
      a1: 0,
      tipoPropiedad: 'Número - Letra del o la casa',
      tipoPropiedad2: 'Número - Letra del o la casa',
      campoDeshabilitado: false,
      campoDeshabilitadoD: false,
      Origen1: true,
      Origen2: false,
      Destino2: false,
      direcciones: {
        destino: '',
        origen: ''
      },
      datos: {
        direccion_origen: {
          direccion: "",
          marker: {},
          direccion_obj: {},
          estacionamiento: "",
        },
        origen: {
          tipo: "Casa",
          piso: 1,
          numero: "",
          mover: "Primer Piso a Primer Piso",
          acopio: {
            distancia: 0,
            valor: 2000,
          },
        },
        direccion_destino: {
          direccion: "",
          marker: {},
          direccion_obj: {},
          estacionamiento: "",
        },
        destino: {
          tipo: "Casa",
          piso: 1,
          numero: "",
          mover: "Primer Piso a Primer Piso",
          acopio: {
            distancia: 0,
            valor: 2000,
          },
        },
      },
      items: ["Casa", "Departamento", "Local", "Parcela", "Condominio"],
      tipoSeleccionado: null,
      rules: {
        control: false,
        required: [(v) => !!v || "Campo obligatorio"],
        direccionOrigen: [
          (v) => !!v || "Campo obligatorio",
          (v) =>
            !!/\d/.test(v) ||
            !this.control ||
            "Por favor ingresa también la numeración.",
          () => {
            if (Object.keys(this.datos.direccion_origen.marker).length > 0) {
              this.Origen2 = true;
              // this.campoDeshabilitado ? this.campoDeshabilitado = false : this.campoDeshabilitado = true  

              return true;
            } else {
              return this.control
                ? "Debe seleccionar una dirección sugerida por Google"
                : true;
            }
          },
        ],
        direccionDestino: [
          (v) => !!v || "Campo obligatorio",
          (v) =>
            !!/\d/.test(v) ||
            !this.control ||
            "Por favor ingresa también la numeración.",
          (v) => {
            if (Object.keys(this.datos.direccion_destino.marker).length > 0) {
              this.Destino2 = true;
              // this.campoDeshabilitadoD ? this.campoDeshabilitadoD = false : this.campoDeshabilitadoD = true  
              return true;
            } else {
              return this.control
                ? "Debe seleccionar una dirección sugerida por Google"
                : true;
            }
          },
        ],
      },
    };
  },
  methods: {
    cambio() {
            this.tipoPropiedad = 'Número - Letra del/la ' + this.datos.origen.tipo
        },
    cambioD() {
            this.tipoPropiedad2 = 'Número - Letra del/la ' + this.datos.destino.tipo
        },
    retroceder() {
      this.eventTracker('goBackThird')
      EventBus.$emit("retroceder", 2);
    },

    validate(move) {
      if (this.datos.direccion_origen.direccion !== "" && this.datos.direccion_destino.direccion !== "") {
        var data = {
          datos: this.datos,
          valid: true,
          move,
        }
        if (move) {
          this.eventTracker('goForwardThird')
          EventBus.$emit("mudanzaThird", data)
        }
      }
    },
    eventTracker(tipo) {
        gtag('event', tipo, {
          'event_category' : tipo,
          'event_label' : tipo
        })
    },
    setAddress(data){
				// Seteamos la data de dirección como promesa para poder esperar que esto esté listo en retomarPedido abajo
      return new Promise((resolve, reject) => {
          const self = this
          const geocoder = new google.maps.Geocoder()
          const origen = new Promise((resolve, reject) => {
              geocoder.geocode({'address': data.direcciones.origen}, function(results, status) {
              if (status === 'OK') {
                  self.datos.direccion_origen.marker = results[0].geometry.location
              } else {
                  alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
              })
          })
          const destino = new Promise((resolve, reject) => {
            geocoder.geocode({'address': data.direcciones.destino}, function(results, status) {
              if (status === 'OK') {
                self.datos.direccion_destino.marker = results[0].geometry.location
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
            })	
          })

          Promise.all([origen, destino]).then(values => { 
            resolve(true)
          });
        })  
      }
     
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      let self = this;
      let options = {
        componentRestrictions: { country: "cl" },
      };

      //Origen
      let starting_address_input = document.getElementById("starting_address");
      let starting_address_autocomplete = new google.maps.places.Autocomplete(
        starting_address_input,
        options
      );
      starting_address_autocomplete.addListener("place_changed", function () {
        let place = starting_address_autocomplete.getPlace();

        self.datos.direccion_origen.direccion_obj = place;
        self.datos.direccion_origen.marker = place.geometry.location;
        self.datos.direccion_origen.direccion = place.formatted_address;
      });
      let destination_address_input = document.getElementById(
        "destination_address"
      );
      let destination_address_autocomplete =
        new google.maps.places.Autocomplete(destination_address_input, options);

      destination_address_autocomplete.addListener(
        "place_changed",

        function () {
          let place = destination_address_autocomplete.getPlace();
          self.datos.direccion_destino.direccion_obj = place;
          self.datos.direccion_destino.marker = place.geometry.location;
          self.datos.direccion_destino.direccion = place.formatted_address;
        }
      );
    });
    EventBus.$on('retomarPedidoThird', data => {
      this.datos.origen = data.third.origen
      this.datos.destino = data.third.destino
      this.datos.direccion_origen.direccion = data.first.direccion_origen.direccion
      this.datos.direccion_destino.direccion = data.first.direccion_destino.direccion
      this.direcciones.origen = data.first.direccion_origen.direccion
      this.direcciones.destino = data.first.direccion_destino.direccion
      const dataDireccion = {
        direcciones: this.direcciones
      }
      this.setAddress(dataDireccion)
      this.a1 = 2
      EventBus.$emit('avanzarRetomar', {e1: 4})
    })
  },
};
</script>